import React, { useState } from 'react';
import './ChatMessage.css';

const ChatMessage = ({ message, onDelete }) => {
  const [showOptions, setShowOptions] = useState(false);

  const isAdmin = message.sender === 'admin';
  const isDriver = message.sender === 'driver';
  const isRestaurant = message.sender === 'restaurant';

  const messageClass = isAdmin
    ? 'admin'
    : isDriver
    ? 'driver'
    : isRestaurant
    ? 'restaurant'
    : 'other';

  const handleDelete = () => {
    if (onDelete && window.confirm('هل أنت متأكد من حذف هذه الرسالة؟ سيتم حذفها من الطرفين.')) {
      onDelete(message.id);
    }
  };

  return (
    <div
      className={`chat-message ${messageClass}`}
      onMouseEnter={() => setShowOptions(true)}
      onMouseLeave={() => setShowOptions(false)}
    >
      <div className="message-bubble">
        <div className="sender-name">👤 {message.senderName || message.sender}</div>
        <p>{message.message}</p>
        <span className="time">
          {new Date(message.timestamp?.toDate?.() || message.timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
        {showOptions && onDelete && (
          <div className="message-options">
            <button onClick={handleDelete} className="delete-button">
              <span className="delete-icon">🗑️</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
